import { computed, unref } from 'vue-demi'

export const useAntdLocale = (language) => {
  return computed(() => {
    return require(`ant-design-vue/lib/locale-provider/${unref(language).replace('-', '_')}`).default
  })
}
